import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import {
  insertCartRequest,
  insertCartSuccess,
  insertCartFailure,
  getCartRequest,
  getCartSuccess,
  getCartFailure,
  removeCartRequest,
  removeCartSuccess,
  removeCartFailure,
  getHomeproductdataRequest,
  getHomeproductdataSuccess,
  getHomeproductdataFailure,
  getsimilarproductdataRequest,
  getsimilarproductdataSuccess,
  getsimilarproductdataFailure,
  getproductbycategoryidRequest,
  getproductbycategoryidSuccess,
  getproductbycategoryidFailure,
  addwishlistrequest,
  addwishlistsuccess,
  addwishlistfailure,
  removewishlistrequest,
  removewishlistsuccess,
  removewishlistfailure,
  getproductbyidRequest,
  getproductbyidSuccess,
  getproductbyidFailure,
  getcategorywithsubcategoryRequest,
  getcategorywithsubcategorySuccess,
  getcategorywithsubcategoryFailure,
  getproductwithbrandRequest,
  getproductwithbrandSuccess,
  getproductwithbrandFailure,
  getsubcategorywithproductRequest,
  getsubcategorywithproductSuccess,
  getsubcategorywithproductFailure,
  getBannersRequest,
  getBannersSuccess,
  getBannersFailure,
} from "./Home-slice";
import axiosInstance from "../../utils/AxiosConfig";
import { showError } from "../../utils/Toast";
import { getBuyerToken } from "../../utils/authStorage";
import { fetchGuestCartItems } from "../../utils/guestCart";

const isSmallBanner = (banner) => {
  const title = String(banner?.title || "").trim().toLowerCase();
  const bannerType = String(
    banner?.banner_type || banner?.type || "",
  ).trim().toLowerCase();

  return (
    bannerType === "small" ||
    bannerType === "small_banner" ||
    bannerType === "small-banner" ||
    title === "small banner" ||
    title.includes("small banner")
  );
};

const isActiveBanner = (banner) => {
  return (
    Number(banner?.active) === 1 ||
    banner?.active === true ||
    String(banner?.active || "").trim().toLowerCase() === "true"
  );
};

const isTopBanner = (banner) =>
  String(banner?.position || "").trim().toLowerCase() === "top";

function* insertCartSaga(action) {
  try {
    const response = yield axiosInstance.post(`addToCart`, action.payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    yield put(insertCartSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || error?.message || "Failed to add product to cart";
    showError(errorMessage);
    yield put(insertCartFailure(errorMessage));
  }
}

export function* watchCartadd() {
  yield takeEvery(insertCartRequest.type, insertCartSaga);
}

function* getCartSaga(action) {
  if (!getBuyerToken()) {
    try {
      const guestCart = yield call(fetchGuestCartItems);
      if (guestCart.missing.length) {
        showError("Some cart items are no longer available and were removed.");
      }
      yield put(
        getCartSuccess({
          success: true,
          data: guestCart.items,
          source: "guest",
        }),
      );
    } catch (error) {
      yield put(getCartFailure(error?.message || "Unable to load guest cart"));
    }
    return;
  }

  try {
    const response = yield axiosInstance.get(`getCart`, {});
    yield put(getCartSuccess(response.data));
  } catch (error) {
    yield put(getCartFailure(error.message));
  }
}

export function* watchgetCart() {
  yield takeLatest(getCartRequest.type, getCartSaga);
}

function* removeCartSaga(action) {
  //   console.log(action.payload);
  try {
    const response = yield axiosInstance.delete(
      `removeFromCart/${action.payload}`,
      {}
    );
    yield put(removeCartSuccess(response.data));
  } catch (error) {
    yield put(removeCartFailure(error.message));
  }
}

export function* watchremoveCart() {
  yield takeLatest(removeCartRequest.type, removeCartSaga);
}

function* getHomeproductSaga(action) {
  const token = getBuyerToken();
  let url = "";
  if (token) {
    url = "getHomeSections";
  } else {
    url = "getHomeSections/public";
  }
  //   console.log(action.payload);
  try {
    const response = yield axiosInstance.get(url, {});
    yield put(getHomeproductdataSuccess(response.data));
  } catch (error) {
    yield put(getHomeproductdataFailure(error.message));
  }
}

export function* watchgetHomeproduct() {
  yield takeLatest(getHomeproductdataRequest.type, getHomeproductSaga);
}

function* getsimilarproductSaga(action) {
  //   console.log(action.payload);
  try {
    const response = yield axiosInstance.get(
      `getSimilarProducts/${action.payload}`,
      {}
    );
    yield put(getsimilarproductdataSuccess(response.data));
  } catch (error) {
    yield put(getsimilarproductdataFailure(error.message));
  }
}

export function* watchgetsimilarproduct() {
  yield takeLatest(getsimilarproductdataRequest.type, getsimilarproductSaga);
}

function* getproductbycategoryidSaga(action) {
  try {
    const response = yield axiosInstance.get(
      `getproductsByCategoryId/${action.payload}`,
      {}
    );
    yield put(getproductbycategoryidSuccess(response.data));
  } catch (error) {
    yield put(getproductbycategoryidFailure(error.message));
  }
}

export function* watchgetproductbycategoryid() {
  yield takeLatest(
    getproductbycategoryidRequest.type,
    getproductbycategoryidSaga
  );
}

function* addwishlistSaga(action) {
  // console.log(action.payload);
  const params = {
    productid: action.payload,
  };
  try {
    const response = yield axiosInstance.post(`addToWishlist`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    yield put(addwishlistsuccess(response.data));
  } catch (error) {
    yield put(addwishlistfailure(error.message));
  }
}

export function* watchaddwishlist() {
  yield takeEvery(addwishlistrequest.type, addwishlistSaga);
}

function* removewishlistSaga(action) {
  const productid = action.payload;
  try {
    const response = yield axiosInstance.delete(`removeFromWishlist`, {
      data: { productid: productid },
    });
    yield put(removewishlistsuccess(response.data));
  } catch (error) {
    yield put(removewishlistfailure(error.message));
  }
}

export function* watchremovewishlist() {
  yield takeEvery(removewishlistrequest.type, removewishlistSaga);
}

function* getproductbyidSaga(action) {
  // console.log(action.payload);
  try {
    const response = yield axiosInstance.get(
      `getProductById/${action.payload}`,
      {}
    );
    yield put(getproductbyidSuccess(response.data));
  } catch (error) {
    yield put(getproductbyidFailure(error.message));
  }
}

export function* watchgetproductbyid() {
  yield takeLatest(getproductbyidRequest.type, getproductbyidSaga);
}

function* getcategorywithsubcategorySaga(action) {
  //   console.log(action.payload);
  try {
    const response = yield axiosInstance.get(
      `getCategoriesWithSubCategories`,
      {}
    );
    yield put(getcategorywithsubcategorySuccess(response.data));
  } catch (error) {
    yield put(getcategorywithsubcategoryFailure(error.message));
  }
}

export function* watchgetcategorywithsubcategory() {
  yield takeLatest(
    getcategorywithsubcategoryRequest.type,
    getcategorywithsubcategorySaga
  );
}

function* getproductwithbrandSaga(action) {
  // console.log(action.payload);
  try {
    const response = yield axiosInstance.get(
      `getProductsByBrandId/${action.payload}`,
      {}
    );
    yield put(getproductwithbrandSuccess(response.data));
    // console.log("brandsaga----->", response.data);
  } catch (error) {
    yield put(getproductwithbrandFailure(error.message));
  }
}

export function* watchgetproductwithbrand() {
  yield takeLatest(getproductwithbrandRequest.type, getproductwithbrandSaga);
}

function* getsubcategorywithproductSaga(action) {
  // console.log(action.payload);
  try {
    const response = yield axiosInstance.get(
      `getsubCategoriesWithProducts/${action.payload}`,
      {}
    );
    yield put(getsubcategorywithproductSuccess(response.data));
    // console.log("brandsaga----->", response.data);
  } catch (error) {
    yield put(getsubcategorywithproductFailure(error.message));
  }
}

export function* watchgetsubcategorywithproduct() {
  yield takeLatest(
    getsubcategorywithproductRequest.type,
    getsubcategorywithproductSaga
  );
}

function* fetchBannersWorker() {
  try {
    const response = yield call(
      axiosInstance.get,
      "/getBannersByUser"
    );

    const bannerData = Array.isArray(response?.data?.data)
      ? response.data.data
      : Array.isArray(response?.data?.banners)
        ? response.data.banners
        : [];
    const banners = bannerData.filter(isActiveBanner);
    const topBanners = banners.filter(
      (banner) => isTopBanner(banner) && !isSmallBanner(banner),
    );
    const smallBannerCandidates = banners.filter(
      (banner) => isTopBanner(banner) && isSmallBanner(banner),
    );
    const bottomBanners = banners.filter(
      (banner) => (banner?.position || "").toLowerCase() === "bottom"
    );
    const smallBanners = [...smallBannerCandidates].sort(
      (left, right) => Number(right?.id || 0) - Number(left?.id || 0)
    );
    const smallBanner = smallBanners[0] || null;

    yield put(
      getBannersSuccess({
        banners,
        topBanners,
        smallBanners,
        smallBanner,
        bottomBanners,
      })
    );
  } catch (error) {
    yield put(getBannersFailure(error?.response?.data?.message || error.message));
  }
}

export function* watchGetBanners() {
  yield takeLatest(getBannersRequest.type, fetchBannersWorker);
}
